export { default } from './GeonameMapHeader';
